import { Box, Frame, Layout, Loading, Page, Text, TextField } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import {
  SupplierMoreInformationInput,
  useSupplierRegisterReviewQuery,
  useUpdateSupplierMoreInformationMutation,
} from "src/graphql/codegen_graphql";
import SellerLocation from "./SellerLoacation";
import { Toast } from "src/hooks/toast";

export function UpdateInfoScreen() {
  const q = new URLSearchParams(window.location.search);
  const [info, setInfo] = useState<SupplierMoreInformationInput>({
    address: "",
    companyName: "",
  });
  const { loading } = useSupplierRegisterReviewQuery({
    variables: {
      verifyToken: q.get("passkey") || "",
    },
    onCompleted: (res) => {
      if (res.supplierRegisterReview) {
        setInfo(
          ({
            ...res.supplierRegisterReview,
            coordLat: res.supplierRegisterReview.coordLat || 0,
            coordLng: res.supplierRegisterReview.coordLng || 0,
            address: res.supplierRegisterReview.address || "",
          } || {
            address: "",
            companyName: "",
            coordLat: 0,
            coordLng: 0,
          }) as SupplierMoreInformationInput,
        );
      }
    },
  });
  const [updateSupplier] = useUpdateSupplierMoreInformationMutation();

  const handleSave = useCallback(() => {
    if (info) {
      if (!info.coordLat || !info.coordLng) {
        return Toast.onShow("Invalid location address", "danger", "right");
      }
      updateSupplier({
        variables: {
          data: {
            address: String(info.address || ""),
            companyName: String(info.companyName || ""),
            bankAccHolderName: String(info.bankAccHolderName || ""),
            bankAccNumber: String(info.bankAccNumber || ""),
            bankName: String(info.bankName || ""),
            brandsNames: String(info.brandsNames || ""),
            companyRegisterNumber: String(info.companyRegisterNumber || ""),
            contact: String(info.contact || ""),
            coordLat: String(info.coordLat || ""),
            coordLng: String(info.coordLng || ""),
            fiscalCodeNumber: String(info.fiscalCodeNumber || ""),
            isSeller: info.isSeller,
            vat: String(info.vat || ""),
          },
          verifyToken: q.get("passkey") || "",
        },
      }).then((res) => {
        if (res.data?.updateSupplierMoreInformation) {
          Toast.onShow("Seller information was updated.", "success", "right");
        }
      });
    }
  }, [info, q, updateSupplier]);

  return (
    <Page title="Seller Information" fullWidth primaryAction={{ content: "Save", onAction: handleSave }}>
      {loading && (
        <Frame>
          <Loading />
        </Frame>
      )}
      <Layout>
        <Layout.Section variant="oneThird">
          <PolarisCard>
            <Box>
              <Text as="h3" variant="headingMd">
                Company
              </Text>
            </Box>
            <br />
            <Box>
              <TextField
                label="Name"
                labelHidden
                prefix="Name"
                autoComplete="off"
                value={info.companyName}
                onChange={(v) => setInfo({ ...info, companyName: v })}
              />
              <br />
              <TextField
                label="Register Number"
                labelHidden
                prefix="Register Name"
                autoComplete="off"
                value={info.companyRegisterNumber || ""}
                onChange={(v) => setInfo({ ...info, companyRegisterNumber: v })}
              />
            </Box>
            <br />
            <Box>
              <Text as="h3" variant="headingMd">
                Other
              </Text>
            </Box>
            <br />
            <Box>
              <TextField
                label="Brand Name"
                labelHidden
                prefix="Brand Name"
                autoComplete="off"
                value={info.brandsNames || ""}
                onChange={(v) => setInfo({ ...info, brandsNames: v })}
              />
              <br />
              <TextField
                label="Contact"
                labelHidden
                prefix="Contact"
                autoComplete="off"
                value={info.contact || ""}
                onChange={(v) => setInfo({ ...info, contact: v })}
              />
              <br />
              <TextField
                label=""
                labelHidden
                prefix="Fiscal Code"
                autoComplete="off"
                value={info.fiscalCodeNumber || ""}
                onChange={(v) => setInfo({ ...info, fiscalCodeNumber: v })}
              />
              <br />
              <TextField
                label=""
                labelHidden
                prefix="Vat"
                autoComplete="off"
                value={info.vat || ""}
                onChange={(v) => setInfo({ ...info, vat: v })}
              />
            </Box>
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <PolarisCard>
            <Box>
              <Text as="h3" variant="headingMd">
                Bank
              </Text>
            </Box>
            <br />
            <Box>
              <TextField
                label=""
                labelHidden
                prefix="Bank Name"
                autoComplete="off"
                value={info.bankName || ""}
                onChange={(v) => setInfo({ ...info, bankName: v })}
              />
              <br />
              <TextField
                label=""
                labelHidden
                prefix="Holder Name"
                autoComplete="off"
                value={info.bankAccHolderName || ""}
                onChange={(v) => setInfo({ ...info, bankAccHolderName: v })}
              />
              <br />
              <TextField
                label=""
                labelHidden
                prefix="Number"
                autoComplete="off"
                value={info.bankAccNumber || ""}
                onChange={(v) => setInfo({ ...info, bankAccNumber: v })}
              />
            </Box>
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <PolarisCard>
            <Box>
              <Text as="h3" variant="headingMd">
                Address
              </Text>
            </Box>
            <br />
            <Box>
              <div>
                {!loading && (
                  <SellerLocation
                    lat={Number(info.coordLat || 0)}
                    lng={Number(info.coordLng || 0)}
                    addressName={info.address || ""}
                    onChange={(lat, lng, addressName) => {
                      setInfo({
                        ...info,
                        coordLat: lat.toString(),
                        coordLng: lng.toString(),
                        address: addressName,
                      });
                    }}
                  />
                )}
              </div>
            </Box>
          </PolarisCard>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
